import {
  CategoryNavigationMenu,
  CategoryNavigationMenuDisplayList,
  CategoryNavigationMenuPath,
  CategoryNavigationMenuText,
} from '@diritto/common/navigation/constant';
import styled from '@emotion/styled';
import { ExploreNavigationMenu, ExploreNavigationMenuPath } from '@diritto/common/navigation/explore';
import { useMemo } from 'react';
import { ContentBodyPadding, GNBSubMenuHeight, MaxContentBodySize } from 'constants/layout';
import { SubMenu } from 'ui-components/navigations/SubMenu';

export const ExploreCategoryNavigationBar = ({
  exploreMenu,
  selectedMenu,
}: {
  selectedMenu: CategoryNavigationMenu;
  exploreMenu: ExploreNavigationMenu;
}) => {
  const path = useMemo(
    () => ({
      [CategoryNavigationMenu.All]: `/explore/${ExploreNavigationMenuPath[exploreMenu]}/${
        CategoryNavigationMenuPath[CategoryNavigationMenu.All]
      }`,
      [CategoryNavigationMenu.Fantasy]: `/explore/${ExploreNavigationMenuPath[exploreMenu]}/${
        CategoryNavigationMenuPath[CategoryNavigationMenu.Fantasy]
      }`,
      [CategoryNavigationMenu.BL]: `/explore/${ExploreNavigationMenuPath[exploreMenu]}/${
        CategoryNavigationMenuPath[CategoryNavigationMenu.BL]
      }`,
      [CategoryNavigationMenu.RomanceFantasy]: `/explore/${ExploreNavigationMenuPath[exploreMenu]}/${
        CategoryNavigationMenuPath[CategoryNavigationMenu.RomanceFantasy]
      }`,
      [CategoryNavigationMenu.Romance]: `/explore/${ExploreNavigationMenuPath[exploreMenu]}/${
        CategoryNavigationMenuPath[CategoryNavigationMenu.Romance]
      }`,
      [CategoryNavigationMenu.Any]: `/explore/${ExploreNavigationMenuPath[exploreMenu]}/${
        CategoryNavigationMenuPath[CategoryNavigationMenu.Any]
      }`,
    }),
    [exploreMenu],
  );

  return (
    <StyledContainer>
      <StyledSubMenu
        menuList={CategoryNavigationMenuDisplayList}
        menuPath={path}
        menuText={CategoryNavigationMenuText}
        selectedMenu={selectedMenu}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  width: 100%;
  height: ${GNBSubMenuHeight}px;
  position: relative;
  display: flex;
  padding: 0 ${ContentBodyPadding}px;
  max-width: ${MaxContentBodySize}px;
`;

const StyledSubMenu = styled(SubMenu)``;
